export const COLOR_LIGHT = 'light';
export const COLOR_DARK = 'dark';
